import React from "react";
import { Flex } from "/app/src/component";
import style from "./style.css";

class Item extends React.Component {
  render() {
    let styling = style.resetTextMargin + " " + style.item + " ellipsis";
    if (this.props.activeItemId === this.props.id)
      styling += " " + style.active;
    return (
      <Flex
        className={styling}
        vAlignContent="center"
        borderBottom="1px solid #707070"
        width="inherit"
        onClick={this.props.onClick}
      >
        <Flex center width="25%" className="ellipsis">
          <p className={style.dataText}>
            {this.props.companyCustomerId || "Ingen ID"}
          </p>
        </Flex>
        <Flex center width="25%" className="ellipsis">
          <p className={style.dataText}> {this.props.name || "Ej angiven"} </p>
        </Flex>
        <Flex center width="25%" className="ellipsis">
          <p className={style.dataText}> {this.props.phone || "Ej angiven"} </p>
        </Flex>
        <Flex center width="25%" className="ellipsis">
          <p className={style.dataText}> {this.props.email || "Ej angiven"} </p>
        </Flex>
      </Flex>
    );
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Search/Customer/Item/index.js